import { useProspectSearchStore } from '../stores/prospectSearchStore.js'

export function useProspectsSearch() {
  const loading = useProspectSearchStore((s) => s.loading)
  const error = useProspectSearchStore((s) => s.error)
  const results = useProspectSearchStore((s) => s.results)
  const search = useProspectSearchStore((s) => s.startSearch)
  const reset = useProspectSearchStore((s) => s.reset)
  const setResults = useProspectSearchStore((s) => s.setResults)

  return { loading, error, results, search, reset, setResults }
}
